import { ReactComponent as BkgComponent } from '../assets/bkg-maths.svg';
import SvgRouteNavigator from '../components/SvgRouteNavigator';

const linkRoutes: Record<string, string> = {
  "link-cycle-1": "/maths/cycle/1",
  "link-cycle-2": "/maths/cycle/2",
  "link-cycle-3": "/maths/cycle/3",
  "link-misc": "/maths/misc",
  "link-back": "/main",
};

function Maths() {
  return <SvgRouteNavigator SvgComponent={BkgComponent} linkRoutes={linkRoutes} />;
}

export default Maths;
